import { styled } from '@linaria/react';

export const HomePageWrapper = styled.main`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: #000;
`;
